/**
 * Currently A/B testing this dropdown from the site header concept
 *
 * Should be moved into copycat with the main site-header styles if
 * we stick with this and roll it out elseware
 */
import '../polyfills/web_components'
import './expando.scss'
import './mobile_nav_overrides.scss'

const OPEN_CLASS = 'pe-site-header__item--expando--open'
const CLOSED_CLASS = 'pe-site-header__item--expando--closed'

$(() => {
  const closeOnContentClick = () => {
    $('.pe-site-header__item--expando--open')
      .addClass(CLOSED_CLASS)
      .removeClass(OPEN_CLASS)
    $('#main').off('click', closeOnContentClick)
  }

  $('.pe-site-header__item--expando')
    .filter((_index, el) => !$(el).data('expando'))
    .data('expando', true)
    .click(function (e) {
      const $expando = $(this)
      const isOpen = $expando.hasClass(OPEN_CLASS)

      // Close any others that are open
      $('.pe-site-header__item--expando--open').not($expando)
        .addClass(CLOSED_CLASS)
        .removeClass(OPEN_CLASS)

      // Toggle this expando
      $expando
        .toggleClass(OPEN_CLASS, !isOpen)
        .toggleClass(CLOSED_CLASS, isOpen)

      $('#main').on('click', closeOnContentClick)
    })

  // This was only there while our CSS loaded
  $('.pe-site-header__expando-container').removeAttr('hidden')

  // remove scroll from main page when this is expanded
  $('.pe-site-header__expand, .pe-site-header__expansion__close').on('click', function (e) {
    // wait until animation is done
    setTimeout(function () {
      const expanded = $('.pe-site-header__expansion--open').length === 1
      $('html').toggleClass('noscroll', expanded)
      $('body').toggleClass('noscroll', expanded)
    }, 200)
  })
})
